namespace appn.views.introduction.index {

    class InitArgs {
        currentStep: number = 1;
        createNewDSUrl: string = appn.emptyString;
        dataSourceRows: string = appn.emptyString;
        saveConsentUrl: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    const _maxSteps: number = 8;
    let _introLocalStorageKey: string = '';

    export function init(args: InitArgs): void {
        _initArgs = args;
        _introLocalStorageKey = `productIntroState-${appn.requestProvider.id}`;

        addEvents();

        appn.posthog.capture('introduction_viewed', { introStep: _initArgs.currentStep });

        if (appn.requestUser.allowUsageAnalytics === null || appn.requestUser.allowUsageAnalytics === undefined)
            $('#usage-analytics-modal').css('display', 'flex').show();
        

        if (!appn.utils.hasValue(window.location.search))
            appn.posthog.capture('signup');
        
        findCurrentStep();
    }

    function addEvents() {

        $('.btn-product-intro-next').on('click', function(e) {
            e.preventDefault();

            appn.localStorage.setItem(_introLocalStorageKey, {
                currentStep: _initArgs.currentStep + 1
            });

            const nextStepUrl = $(this).attr('href') as string;

            appn.location.navTo(nextStepUrl);
        });

        $('.btn-product-intro-back').on('click', function(e) {
            e.preventDefault();

            appn.localStorage.setItem(_introLocalStorageKey, {
                currentStep: _initArgs.currentStep - 1
            });

            const nextStepUrl = $(this).attr('href') as string;

            appn.location.navTo(nextStepUrl);
        });

        $('.btn-product-intro-skip,.btn-product-intro-complete').on('click', function(e) {

            // Reset intro
            appn.localStorage.setItem(_introLocalStorageKey, {
                currentStep: 1
            });
        });

        $('.btn-product-intro-skip').hover(function() {
            $('.skip-message').toggleClass('show');
        });

        $('.create-ds').on('click', function(e) {
            e.preventDefault();

            const data = { name: T('My First Data Source'), items: [] };

            $.ajax({
                url: _initArgs.createNewDSUrl,
                type: 'POST',
                contentType: 'application/json, charset=utf-8',
                data: JSON.stringify(data),
                success: function(result: any) {
                    appn.location.navTo(_initArgs.dataSourceRows, [
                        {name: 'id', value: result.Id},
                        {name: 'isShowImport', value: true}
                    ], appn.emptyString, true);
                },
                error: function() {}
            });
        });

        $('#btn-usage-analytics-accept, #btn-usage-analytics-decline').on('click', function (e) {
            e.preventDefault();
            const isAllowed = $(this).attr('id') === 'btn-usage-analytics-accept';
            saveUsageAnalyticsConsent(isAllowed);
        });
    }

    function saveUsageAnalyticsConsent(isAllowed: boolean) {
        const data = { allowTracking: isAllowed };

        $.ajax({
            headers: appn.verifyHeader,
            url: _initArgs.saveConsentUrl,
            data: data,
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded; charset=utf-8',
            dataType: 'json',
            success: function() {
                // Update local session object so PostHog logic responds immediately
                appn.requestUser.allowUsageAnalytics = isAllowed;
                $('#usage-analytics-modal').fadeOut();

                if (isAllowed)
                    appn.posthog.capture('introduction_viewed', { introStep: _initArgs.currentStep });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if (!errorThrown || textStatus === 'parsererror')
                    errorThrown = appn.strings.errorRetrievingData;
                appn.toast.notify(appn.toast.Type.error, errorThrown);
            }
        });
    }
    
    export function findCurrentStep(): void {

        // Check if already completed
        var introState = appn.localStorage.getItem(_introLocalStorageKey);
        if (!utils.hasValue(introState)) {
            introState = {
                currentStep: 1
            };
        }

        if (introState.currentStep >= _maxSteps)
            return; // Already complete

        let url = `${appn.urls.introduction.index}?step=${introState.currentStep}`;

        if (appn.location.urlContains(appn.urls.introduction.index))
            if (!appn.location.urlContains(`step=${introState.currentStep.toString()}`))
                // Redirect to the product intro
                appn.location.navTo(url);
    }
}
